import React, { useState } from 'react';
import ConfirmModal from './ConfirmModal';

export const REQUIRES_HIGHER_PERMISSION = 'Requires higher permission';

// True when an API error is the backend's "this needs a higher role" response.
export const isPermissionError = (err) => err?.response?.data?.code === 'REQUIRES_HIGHER_PERMISSION';

// A control the current user isn't allowed to use. It stays visible but locked, and explains why
// when clicked — rather than being hidden, or failing with a generic error after the fact.
// `what` completes the sentence "Only a Pizzacini administrator can …".
export default function LockedAction({ children, what = 'do this', className = 'btn btn-sm btn-outline-secondary', style }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={className}
        style={{ opacity: 0.6, ...style }}
        title={REQUIRES_HIGHER_PERMISSION}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        🔒 {children}
      </button>
      <ConfirmModal
        show={open}
        title={REQUIRES_HIGHER_PERMISSION}
        message={<>Only a Pizzacini administrator can {what}. Please contact them if this needs to change.</>}
        confirmLabel="OK"
        hideCancel
        variant="primary"
        onConfirm={() => setOpen(false)}
        onCancel={() => setOpen(false)}
      />
    </>
  );
}
